// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"523":"1a0a042d","620":"d483f59c","629":"7547ad30","820":"fe4558e2"}[chunkId] + ".chunk.css";
};